<template>
    <a href="#"
       class="show-more"
       v-scroll-to="{
        el: target,
        duration: 1000
       }"
    >
        {{ buttonText }}
    </a>
</template>

<script>
    export default {
        props: {
            buttonText: {
                required: true,
                type: String
            },
            target: {
                required: true,
                type: String
            }
        }
    }
</script>
